// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Montserrat);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css2?family=Roboto+Condensed);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .webix_view{
  	font-family:Montserrat, serif;
  } */

.webix_view {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-size: 12px;
}

.erpx_text_condensed {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
}

.condensed_uppercase {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
}

.webix_control button,
.webix_control input,
.webix_control textarea,
.webix_el_label,
.webix_inp_bottom_label,
.webix_inp_label,
.webix_inp_top_label {
  font-family: "Roboto Condensed", "PT Sans", Tahoma;
}

.webix_ss_header,
.webix_el_tabbar {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
}

.webix_section .webix_template {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
}

.webix_menu-x.erpx_menu {
  background-color: #005073;
}

.webix_menu-x.erpx_menu .webix_popup.webix_menu {
  background-color: #005073;
}

.webix_menu-x.erpx_menu .webix_popup.webix_menu>.webix_win_content {
  padding: 1px;
}

.webix_menu-x.erpx_menu .webix_list_item.menu {
  background-color: #005073;
  border-right: 1px solid rgb(22 69 99);
}

.webix_list_item.menu.webix_selected {
  background-color: burlywood;
}

.webix_context_separator {}

.webix_menu-x.erpx_menu .webix_list_item .webix_submenu_icon {
  margin-left: 7px;
}

.webix_menu-x.erpx_menu .webix_list_item:hover,
.webix_menu-x.erpx_menu .webix_list_item:active,
.webix_menu-x.erpx_menu .webix_list_item:focus {
  background: #107dac;
}

.erpx_submenu .webix_list_item.menu {
  background: #005073;
  color: white;
}

.erpx_submenu .webix_list_item.menu:hover {
  background: #107dac;
}

.webix_menu-x.erpx_menu .webix_list_item:first-child {
  border-radius: 0 !important;
  width: 175px !important;
}

.webix_menu-x.erpx_menu .webix_list_item:last-child {
  border-radius: 0 !important;
}

.webix_toolbar .webix_el_icon .webix_el_box {
  border-radius: 0 !important;
}

/** proto css */
.erpx_lv_stacked>.webix_el_box {
  line-height: normal !important;
}

.erpx_lv_stacked .erpx_lv.erpx_lv_label {
  height: 15px;
  line-height: 15px;
  font-size: 11px;
  color: #aaa;
  text-transform: uppercase;
}

.erpx_lv_stacked .erpx_lv.erpx_lv_value {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}

.erpx_lv_inline .erpx_lv.erpx_lv_label,
.erpx_lv_inline .erpx_lv.erpx_lv_value {
  display: inline-block;
}

.erpx_lv_inline .erpx_lv.erpx_lv_label {
  color: #aaa;
  /* text-transform: uppercase; */
}

.erpx_lv_raw {
  background-color: inherit;
  padding-top: 5px;
}

.erpx_lv_inline .erpx_lv_raw {
  padding-top: 5px;
}

.erpx_lv_inline .erpx_lv_raw.erpx_lv_label {
  padding-left: 3px;
}

.erpx_lv_raw .webix_template {
  padding: 0 !important;
}

.erpx_lv_stacked .erpx_lv_raw.erpx_lv_value {
  padding-top: 5px;
}

.erpx_lv_raw.erpx_lv_value td {
  padding-left: 3px;
  padding-right: 3px;
}

.webix_column .webix_cell .webix_el_button button {
  color: #494949 !important;
  text-transform: uppercase;
  text-decoration: none;
  background: #ffffff;
  border: 1px solid #494949 !important;
  font-size: 10px;
  display: inline-block;
  transition: all 0.4s ease 0s;
  border-radius: 3px;
  margin-right: 3px;
  font-family: "Roboto Condensed", "PT Sans", Tahoma;
}

.webix_column .webix_cell .webix_el_button button .webix_icon.mdi {
  font-size: 12px;
  height: 14px;
  padding-top: 2px;
}

.webix_column .webix_cell .webix_el_button button:hover {
  color: #ffffff !important;
  background: #f6b93b;
  border-color: #f6b93b !important;
  transition: all 0.4s ease 0s;
}

.erpx_lv_raw.erpx_lv_value ul {
  padding-left: 20px;
  margin-top: 0px;
}

/** table **/
.erpx_table_row_green {
  color: #313131;
  background-color: #3c98437d;
}


.erpx_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  background-color: #fff;
  background-clip: border-box;
}

.erpx_card-body {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  flex: 1 1 auto;
}

.erpx_card-row {
  display: flex;
  margin-right: -15px;
  margin-left: -15px;
  flex-wrap: wrap;
}

.erpx_card-col {
  ax-width: 100%;
  flex-basis: 0;
  flex-grow: 1;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.erpx_card-title {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
  margin-bottom: 0 !important;
  text-transform: uppercase !important;
  color: #8898aa !important;
  font-size: 1rem;
  margin-top: 0.5rem !important;
  font-weight: 600;
  line-height: 1.5;
}

.erpx_card-value {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
  font-weight: 600 !important;
  margin-bottom: 0 !important;
  font-size: 1.5rem;
  line-height: 1.5;
  color: #32325d;
}

.erpx_card-col-auto {
  width: auto;
  max-width: none;
  flex: 0 0 auto;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 5px;
}

.erpx_card-icon {
  width: 2.5rem;
  height: 2.5rem;

  display: inline-flex;
  padding: 12px;
  text-align: center;
  align-items: center;
  justify-content: center;

  color: #fff !important;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;

  border-radius: 50% !important;
}

.erpx_card-icon i {
  font-size: 1.75rem;
}

.erpx_card-subtitle {
  font-family: "Roboto Condensed", "Roboto", Helvetica, Arial, sans-serif;
  font-size: 0.875rem !important;
  color: #8898aa !important;
  margin-top: 0.1rem !important;
  margin-bottom: 0 !important;
  font-weight: 300;
  line-height: 1.7;
}

.erpx_card-subtitle-value {
  margin-right: 0.5rem !important;
}

.erpx_card-subtitle-desc {
  white-space: nowrap !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/webix/css/erpx.css"],"names":[],"mappings":"AACA;;KAEK;;AAIL;EACE,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,uEAAuE;EACvE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,kDAAkD;AACpD;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EAIzB,qCAAqC;AAHvC;;AAMA;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;;EAEZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;;EAEvB,sBAAsB;EACtB,2DAA2D;;EAE3D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;EACvE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["@import url(//fonts.googleapis.com/css?family=Montserrat);\n/* .webix_view{\n  \tfont-family:Montserrat, serif;\n  } */\n@import url(//fonts.googleapis.com/css?family=Roboto);\n@import url(//fonts.googleapis.com/css2?family=Roboto+Condensed);\n\n.webix_view {\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n}\n\n.erpx_text_condensed {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n}\n\n.condensed_uppercase {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n  text-transform: uppercase;\n}\n\n.webix_control button,\n.webix_control input,\n.webix_control textarea,\n.webix_el_label,\n.webix_inp_bottom_label,\n.webix_inp_label,\n.webix_inp_top_label {\n  font-family: \"Roboto Condensed\", \"PT Sans\", Tahoma;\n}\n\n.webix_ss_header,\n.webix_el_tabbar {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n}\n\n.webix_section .webix_template {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n}\n\n.webix_menu-x.erpx_menu {\n  background-color: #005073;\n}\n\n.webix_menu-x.erpx_menu .webix_popup.webix_menu {\n  background-color: #005073;\n}\n\n.webix_menu-x.erpx_menu .webix_popup.webix_menu>.webix_win_content {\n  padding: 1px;\n}\n\n.webix_menu-x.erpx_menu .webix_list_item.menu {\n  background-color: #005073;\n}\n\n.webix_menu-x.erpx_menu .webix_list_item.menu {\n  border-right: 1px solid rgb(22 69 99);\n}\n\n.webix_list_item.menu.webix_selected {\n  background-color: burlywood;\n}\n\n.webix_context_separator {}\n\n.webix_menu-x.erpx_menu .webix_list_item .webix_submenu_icon {\n  margin-left: 7px;\n}\n\n.webix_menu-x.erpx_menu .webix_list_item:hover,\n.webix_menu-x.erpx_menu .webix_list_item:active,\n.webix_menu-x.erpx_menu .webix_list_item:focus {\n  background: #107dac;\n}\n\n.erpx_submenu .webix_list_item.menu {\n  background: #005073;\n  color: white;\n}\n\n.erpx_submenu .webix_list_item.menu:hover {\n  background: #107dac;\n}\n\n.webix_menu-x.erpx_menu .webix_list_item:first-child {\n  border-radius: 0 !important;\n  width: 175px !important;\n}\n\n.webix_menu-x.erpx_menu .webix_list_item:last-child {\n  border-radius: 0 !important;\n}\n\n.webix_toolbar .webix_el_icon .webix_el_box {\n  border-radius: 0 !important;\n}\n\n/** proto css */\n.erpx_lv_stacked>.webix_el_box {\n  line-height: normal !important;\n}\n\n.erpx_lv_stacked .erpx_lv.erpx_lv_label {\n  height: 15px;\n  line-height: 15px;\n  font-size: 11px;\n  color: #aaa;\n  text-transform: uppercase;\n}\n\n.erpx_lv_stacked .erpx_lv.erpx_lv_value {\n  height: 20px;\n  line-height: 20px;\n  font-size: 14px;\n}\n\n.erpx_lv_inline .erpx_lv.erpx_lv_label,\n.erpx_lv_inline .erpx_lv.erpx_lv_value {\n  display: inline-block;\n}\n\n.erpx_lv_inline .erpx_lv.erpx_lv_label {\n  color: #aaa;\n  /* text-transform: uppercase; */\n}\n\n.erpx_lv_raw {\n  background-color: inherit;\n  padding-top: 5px;\n}\n\n.erpx_lv_inline .erpx_lv_raw {\n  padding-top: 5px;\n}\n\n.erpx_lv_inline .erpx_lv_raw.erpx_lv_label {\n  padding-left: 3px;\n}\n\n.erpx_lv_raw .webix_template {\n  padding: 0 !important;\n}\n\n.erpx_lv_stacked .erpx_lv_raw.erpx_lv_value {\n  padding-top: 5px;\n}\n\n.erpx_lv_raw.erpx_lv_value td {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.webix_column .webix_cell .webix_el_button button {\n  color: #494949 !important;\n  text-transform: uppercase;\n  text-decoration: none;\n  background: #ffffff;\n  border: 1px solid #494949 !important;\n  font-size: 10px;\n  display: inline-block;\n  transition: all 0.4s ease 0s;\n  border-radius: 3px;\n  margin-right: 3px;\n  font-family: \"Roboto Condensed\", \"PT Sans\", Tahoma;\n}\n\n.webix_column .webix_cell .webix_el_button button .webix_icon.mdi {\n  font-size: 12px;\n  height: 14px;\n  padding-top: 2px;\n}\n\n.webix_column .webix_cell .webix_el_button button:hover {\n  color: #ffffff !important;\n  background: #f6b93b;\n  border-color: #f6b93b !important;\n  transition: all 0.4s ease 0s;\n}\n\n.erpx_lv_raw.erpx_lv_value ul {\n  padding-left: 20px;\n  margin-top: 0px;\n}\n\n/** table **/\n.erpx_table_row_green {\n  color: #313131;\n  background-color: #3c98437d;\n}\n\n\n.erpx_card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 0.375rem;\n  background-color: #fff;\n  background-clip: border-box;\n}\n\n.erpx_card-body {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  flex: 1 1 auto;\n}\n\n.erpx_card-row {\n  display: flex;\n  margin-right: -15px;\n  margin-left: -15px;\n  flex-wrap: wrap;\n}\n\n.erpx_card-col {\n  ax-width: 100%;\n  flex-basis: 0;\n  flex-grow: 1;\n\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.erpx_card-title {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n  margin-bottom: 0 !important;\n  text-transform: uppercase !important;\n  color: #8898aa !important;\n  font-size: 1rem;\n  margin-top: 0.5rem !important;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.erpx_card-value {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n  font-weight: 600 !important;\n  margin-bottom: 0 !important;\n  font-size: 1.5rem;\n  line-height: 1.5;\n  color: #32325d;\n}\n\n.erpx_card-col-auto {\n  width: auto;\n  max-width: none;\n  flex: 0 0 auto;\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 5px;\n}\n\n.erpx_card-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n\n  display: inline-flex;\n  padding: 12px;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n\n  color: #fff !important;\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n\n  border-radius: 50% !important;\n}\n\n.erpx_card-icon i {\n  font-size: 1.75rem;\n}\n\n.erpx_card-subtitle {\n  font-family: \"Roboto Condensed\", \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 0.875rem !important;\n  color: #8898aa !important;\n  margin-top: 0.1rem !important;\n  margin-bottom: 0 !important;\n  font-weight: 300;\n  line-height: 1.7;\n}\n\n.erpx_card-subtitle-value {\n  margin-right: 0.5rem !important;\n}\n\n.erpx_card-subtitle-desc {\n  white-space: nowrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
